// eslint-disable-next-line no-unused-vars
module.exports = function(options) {
	console.log('common config');
	return {
		apiKey: 'AIzaSyATqkHo5uKUghS2bcvTt0phbi2J8mM2xqI'
		// common config here
	};
};
